module.exports = "/_next/static/images/SANTAI_MSIG-e5da4e285c11faca722b353faaa0af23.svg";